// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/sudoku/Sudoku.css */

.sudoku-board {
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 98%;
  max-width: 400px;
  max-height: 95vh;
  background: #121212;
  border: 2px solid #334155;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.9);
  color: #e2e8f0;
  font-family: 'Courier New', monospace;
  box-sizing: border-box;
  z-index: 6000;
  outline: none;
}

.sudoku-board.size-4 {
    max-width: 320px;
}

/* HEADER */
.sudoku-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  margin-bottom: 10px;
  background: #1e293b;
  border-radius: 6px;
  border: 1px solid #334155;
}

.sudoku-stat {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 5px;
}
.sudoku-stat.mistakes { color: #ef4444; }
.sudoku-stat.score { color: #fbbf24; }

/* GRID CONTAINER */
.sudoku-grid-wrapper {
  position: relative;
  width: 100%;
  padding-top: 100%; /* Aspect Ratio 1:1 */
  margin-bottom: 10px;
}

.sudoku-grid {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  display: grid;
  border: 2px solid #94a3b8;
  background: #0f172a;
  gap: 0;
}

/* DYNAMIC GRIDS */
.sudoku-grid.size-9 {
    grid-template-columns: repeat(9, 1fr);
    grid-template-rows: repeat(9, 1fr);
}

.sudoku-grid.size-4 {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(4, 1fr);
}

/* CELL STYLING */
.sudoku-cell {
  border: 1px solid #334155;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.1s;
  overflow: hidden;
}

.sudoku-grid.size-9 .sudoku-cell { font-size: 24px; }
.sudoku-grid.size-4 .sudoku-cell { font-size: 36px; }

/* Logic Borders (Blocks) */
.sudoku-grid.size-9 .sudoku-cell:nth-child(3n) { border-right: 2px solid #94a3b8; }
.sudoku-grid.size-9 .sudoku-cell:nth-child(9n) { border-right: none; }
.sudoku-grid.size-9 .sudoku-cell:nth-child(n+19):nth-child(-n+27),
.sudoku-grid.size-9 .sudoku-cell:nth-child(n+46):nth-child(-n+54) {
    border-bottom: 2px solid #94a3b8;
}

.sudoku-grid.size-4 .sudoku-cell:nth-child(2n) { border-right: 2px solid #94a3b8; }
.sudoku-grid.size-4 .sudoku-cell:nth-child(4n) { border-right: none; }
.sudoku-grid.size-4 .sudoku-cell:nth-child(n+5):nth-child(-n+8) {
    border-bottom: 2px solid #94a3b8;
}

/* --- STATES & COLORS --- */

/* Fixed / User Values */
.sudoku-cell.fixed { color: #94a3b8; background: #0f172a; }
.sudoku-cell.user-val { color: #38bdf8; } /* Верные/введенные - голубые */
.sudoku-cell.error { color: #ef4444; background: rgba(239, 68, 68, 0.2) !important; }

/* Selected Cell - Logic depends on MODE (Input vs Notes) */

/* 1. Normal Mode (Input Real Numbers) - Orange Theme */
.sudoku-board.mode-input .sudoku-cell.selected {
    background: rgba(251, 191, 36, 0.8); /* Оранжевый */
    color: #000;
}

/* 2. Note Mode (Candidates) - Gray Theme */
.sudoku-board.mode-notes .sudoku-cell.selected {
    background: rgba(217, 217, 217, 0.8); /* Серая заливка 40% */
    color: #000;
    box-shadow: none;
}

/* Highlighted (Row/Col/Same Number) */
.sudoku-cell.highlighted.mode-input { background: rgba(109, 207, 249, 0.15); }
.sudoku-cell.highlighted.mode-notes { background: rgba(255, 255, 255, 0.1); }
.sudoku-cell.same-num { background: rgba(255, 111, 188, 0.2); font-weight: 900; }


/* --- NOTES (Pencil Marks) --- */
.sudoku-notes {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  display: grid;
  pointer-events: none;
  z-index: 5;
}

.sudoku-notes.grid-3 {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
}
.sudoku-notes.grid-2 {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
}

.note-num {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1; /* Кандидаты серые */
  opacity: 0.7;
  line-height: 1;
}

.sudoku-notes.grid-3 .note-num { font-size: 10px; font-weight: 700; }
.sudoku-notes.grid-2 .note-num { font-size: 14px; font-weight: 700; }

/* In selected cell, notes should be dark for contrast */
.sudoku-cell.selected .note-num {
    color: #000000;
    opacity: 0.7;
}

/* --- CONTROLS --- */
.sudoku-controls {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
}

.sudoku-tools {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.tool-btn {
  background: #334155;
  border: 2px solid transparent; /* Reserve space for border */
  border-radius: 8px;
  color: #e2e8f0;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: 0 4px 0 #1e293b;
  transition: all 0.2s;
}
.tool-btn:active { transform: translateY(2px); box-shadow: 0 2px 0 #1e293b; }

/* Pencil Button States */
/* 1. Permanent ON - Light Gray Background */
.tool-btn.note-active {
  background: #cbd5e1;
  color: #0f172a;
  box-shadow: 0 4px 0 #94a3b8;
}
/* 2. Temporary ON - Dashed Border */
.tool-btn.note-temp {
  background: #334155; /* Normal bg */
  border: 2px dashed #cbd5e1; /* Жирная пунктирная обводка */
  color: #cbd5e1;
}

/* --- NUMPAD --- */
.numpad {
  display: grid;
  gap: 6px;
  padding: 0 4px;
}
.numpad.col-9 { grid-template-columns: repeat(9, 1fr); }
.numpad.col-4 { grid-template-columns: repeat(4, 1fr); }

.num-btn {
  aspect-ratio: 1/1.2;
  border: 1px solid #475569; /* Вернули рамку */
  border-radius: 6px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 0 rgba(0,0,0,0.3);
  transition: all 0.2s;
  background: #1e293b; /* Темный фон всегда */
}

/* Numpad Colors based on MODE */
.sudoku-board.mode-input .num-btn {
  color: #38bdf8; /* Голубые цифры */
  background: #1e293b;
}

.sudoku-board.mode-input .num-btn:hover {
    background: #2a384c;
}

/* Mode: Notes (Gray) */
.sudoku-board.mode-notes .num-btn {
    background: #94a3b8; /* Серый */
    color: #1e293b;
}
.sudoku-board.mode-notes .num-btn:hover {
    background: #8796ab;;
}


/* --- MODAL (Report) --- */
.ms-modal-overlay {
    position: absolute; top:0; left:0; right:0; bottom:0;
    background: rgba(0,0,0,0.7);
    display: flex; align-items: center; justify-content: center;
    z-index: 7000;
    backdrop-filter: blur(2px);
    border-radius: 12px;
}
.cs-report-card {
    background: #1e293b;
    border: 1px solid #475569;
    padding: 20px;
    border-radius: 12px;
    width: 85%;
    max-width: 350px;
    text-align: center;
    box-shadow: 0 10px 25px rgba(0,0,0,0.5);
}
.cs-report-header { margin-bottom: 15px; }
.cs-report-title { font-size: 20px; font-weight: bold; color: #fff; }
.cs-stats-grid { display: flex; flex-direction: column; gap: 8px; margin-bottom: 15px; }
.cs-stat-row { display: flex; justify-content: space-between; font-size: 16px; border-bottom: 1px solid #334155; padding-bottom: 4px; }
.cs-stat-label { color: #94a3b8; }
.cs-stat-value { font-weight: bold; color: #e2e8f0; }
.cs-stat-value.good { color: #4ade80; }
.cs-stat-value.bad { color: #ef4444; }
.cs-stat-value.rank-text { color: #fbbf24; }
.cs-close-btn {
    width: 100%; padding: 12px;
    background: #3b82f6; color: white; border: none;
    border-radius: 8px; font-weight: bold; cursor: pointer;
}
.cs-close-btn.secondary {
    margin-top: 10px; background: transparent; border: 2px solid #555; color: #aaa;
}

/* MEDIA QUERIES */
@media (max-width: 380px) {
  .sudoku-grid.size-9 .sudoku-cell { font-size: 16px; }
  .sudoku-notes.grid-3 .note-num { font-size: 8px; }
  .numpad { gap: 2px; }
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/sudoku/Sudoku.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,eAAe;EACf,QAAQ,EAAE,SAAS;EACnB,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uCAAuC;EACvC,cAAc;EACd,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,wBAAwB,cAAc,EAAE;AACxC,qBAAqB,cAAc,EAAE;;AAErC,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB,EAAE,qBAAqB;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,MAAM;AACR;;AAEA,kBAAkB;AAClB;IACI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,mCAAmC,eAAe,EAAE;AACpD,mCAAmC,eAAe,EAAE;;AAEpD,2BAA2B;AAC3B,iDAAiD,+BAA+B,EAAE;AAClF,iDAAiD,kBAAkB,EAAE;AACrE;;IAEI,gCAAgC;AACpC;;AAEA,iDAAiD,+BAA+B,EAAE;AAClF,iDAAiD,kBAAkB,EAAE;AACrE;IACI,gCAAgC;AACpC;;AAEA,4BAA4B;;AAE5B,wBAAwB;AACxB,qBAAqB,cAAc,EAAE,mBAAmB,EAAE;AAC1D,wBAAwB,cAAc,EAAE,EAAE,+BAA+B;AACzE,qBAAqB,cAAc,EAAE,6CAA6C,EAAE;;AAEpF,2DAA2D;;AAE3D,uDAAuD;AACvD;IACI,mCAAmC,EAAE,cAAc;IACnD,WAAW;AACf;;AAEA,2CAA2C;AAC3C;IACI,oCAAoC,EAAE,sBAAsB;IAC5D,WAAW;IACX,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC,sCAAsC,qCAAqC,EAAE;AAC7E,sCAAsC,oCAAoC,EAAE;AAC5E,wBAAwB,oCAAoC,EAAE,gBAAgB,EAAE;;;AAGhF,iCAAiC;AACjC;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,YAAY;EAC1C,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;AACtC;AACA;IACI,qCAAqC;IACrC,kCAAkC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,oBAAoB;EACpC,YAAY;EACZ,cAAc;AAChB;;AAEA,iCAAiC,eAAe,EAAE,gBAAgB,EAAE;AACpE,iCAAiC,eAAe,EAAE,gBAAgB,EAAE;;AAEpE,wDAAwD;AACxD;IACI,cAAc;IACd,YAAY;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B,EAAE,6BAA6B;EAC5D,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;AACA,mBAAmB,0BAA0B,EAAE,2BAA2B,EAAE;;AAE5E,yBAAyB;AACzB,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;AACA,oCAAoC;AACpC;EACE,mBAAmB,EAAE,cAAc;EACnC,0BAA0B,EAAE,8BAA8B;EAC1D,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA,gBAAgB,qCAAqC,EAAE;AACvD,gBAAgB,qCAAqC,EAAE;;AAEvD;EACE,mBAAmB;EACnB,yBAAyB,EAAE,kBAAkB;EAC7C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA,gCAAgC;AAChC;EACE,cAAc,EAAE,kBAAkB;EAClC,mBAAmB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB,EAAE,UAAU;IAC/B,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;;;AAGA,2BAA2B;AAC3B;IACI,kBAAkB,EAAE,KAAK,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ;IACpD,2BAA2B;IAC3B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,uCAAuC;AAC3C;AACA,oBAAoB,mBAAmB,EAAE;AACzC,mBAAmB,eAAe,EAAE,iBAAiB,EAAE,WAAW,EAAE;AACpE,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACvF,eAAe,aAAa,EAAE,8BAA8B,EAAE,eAAe,EAAE,gCAAgC,EAAE,mBAAmB,EAAE;AACtI,iBAAiB,cAAc,EAAE;AACjC,iBAAiB,iBAAiB,EAAE,cAAc,EAAE;AACpD,sBAAsB,cAAc,EAAE;AACtC,qBAAqB,cAAc,EAAE;AACrC,2BAA2B,cAAc,EAAE;AAC3C;IACI,WAAW,EAAE,aAAa;IAC1B,mBAAmB,EAAE,YAAY,EAAE,YAAY;IAC/C,kBAAkB,EAAE,iBAAiB,EAAE,eAAe;AAC1D;AACA;IACI,gBAAgB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE,WAAW;AAClF;;AAEA,kBAAkB;AAClB;EACE,mCAAmC,eAAe,EAAE;EACpD,iCAAiC,cAAc,EAAE;EACjD,UAAU,QAAQ,EAAE;AACtB","sourcesContent":["/* games/sudoku/Sudoku.css */\r\n\r\n.sudoku-board {\r\n  position: fixed;\r\n  top: 50%; left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 98%;\r\n  max-width: 400px;\r\n  max-height: 95vh;\r\n  background: #121212;\r\n  border: 2px solid #334155;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px;\r\n  box-shadow: 0 20px 60px rgba(0,0,0,0.9);\r\n  color: #e2e8f0;\r\n  font-family: 'Courier New', monospace;\r\n  box-sizing: border-box;\r\n  z-index: 6000;\r\n  outline: none;\r\n}\r\n\r\n.sudoku-board.size-4 {\r\n    max-width: 320px;\r\n}\r\n\r\n/* HEADER */\r\n.sudoku-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 5px 10px;\r\n  margin-bottom: 10px;\r\n  background: #1e293b;\r\n  border-radius: 6px;\r\n  border: 1px solid #334155;\r\n}\r\n\r\n.sudoku-stat {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n.sudoku-stat.mistakes { color: #ef4444; }\r\n.sudoku-stat.score { color: #fbbf24; }\r\n\r\n/* GRID CONTAINER */\r\n.sudoku-grid-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-top: 100%; /* Aspect Ratio 1:1 */\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.sudoku-grid {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  display: grid;\r\n  border: 2px solid #94a3b8;\r\n  background: #0f172a;\r\n  gap: 0;\r\n}\r\n\r\n/* DYNAMIC GRIDS */\r\n.sudoku-grid.size-9 {\r\n    grid-template-columns: repeat(9, 1fr);\r\n    grid-template-rows: repeat(9, 1fr);\r\n}\r\n\r\n.sudoku-grid.size-4 {\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-template-rows: repeat(4, 1fr);\r\n}\r\n\r\n/* CELL STYLING */\r\n.sudoku-cell {\r\n  border: 1px solid #334155;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  transition: background 0.1s;\r\n  overflow: hidden;\r\n}\r\n\r\n.sudoku-grid.size-9 .sudoku-cell { font-size: 24px; }\r\n.sudoku-grid.size-4 .sudoku-cell { font-size: 36px; }\r\n\r\n/* Logic Borders (Blocks) */\r\n.sudoku-grid.size-9 .sudoku-cell:nth-child(3n) { border-right: 2px solid #94a3b8; }\r\n.sudoku-grid.size-9 .sudoku-cell:nth-child(9n) { border-right: none; }\r\n.sudoku-grid.size-9 .sudoku-cell:nth-child(n+19):nth-child(-n+27),\r\n.sudoku-grid.size-9 .sudoku-cell:nth-child(n+46):nth-child(-n+54) {\r\n    border-bottom: 2px solid #94a3b8;\r\n}\r\n\r\n.sudoku-grid.size-4 .sudoku-cell:nth-child(2n) { border-right: 2px solid #94a3b8; }\r\n.sudoku-grid.size-4 .sudoku-cell:nth-child(4n) { border-right: none; }\r\n.sudoku-grid.size-4 .sudoku-cell:nth-child(n+5):nth-child(-n+8) {\r\n    border-bottom: 2px solid #94a3b8;\r\n}\r\n\r\n/* --- STATES & COLORS --- */\r\n\r\n/* Fixed / User Values */\r\n.sudoku-cell.fixed { color: #94a3b8; background: #0f172a; }\r\n.sudoku-cell.user-val { color: #38bdf8; } /* Верные/введенные - голубые */\r\n.sudoku-cell.error { color: #ef4444; background: rgba(239, 68, 68, 0.2) !important; }\r\n\r\n/* Selected Cell - Logic depends on MODE (Input vs Notes) */\r\n\r\n/* 1. Normal Mode (Input Real Numbers) - Orange Theme */\r\n.sudoku-board.mode-input .sudoku-cell.selected {\r\n    background: rgba(251, 191, 36, 0.8); /* Оранжевый */\r\n    color: #000;\r\n}\r\n\r\n/* 2. Note Mode (Candidates) - Gray Theme */\r\n.sudoku-board.mode-notes .sudoku-cell.selected {\r\n    background: rgba(217, 217, 217, 0.8); /* Серая заливка 40% */\r\n    color: #000;\r\n    box-shadow: none;\r\n}\r\n\r\n/* Highlighted (Row/Col/Same Number) */\r\n.sudoku-cell.highlighted.mode-input { background: rgba(109, 207, 249, 0.15); }\r\n.sudoku-cell.highlighted.mode-notes { background: rgba(255, 255, 255, 0.1); }\r\n.sudoku-cell.same-num { background: rgba(255, 111, 188, 0.2); font-weight: 900; }\r\n\r\n\r\n/* --- NOTES (Pencil Marks) --- */\r\n.sudoku-notes {\r\n  position: absolute;\r\n  top: 0; left: 0; width: 100%; height: 100%;\r\n  display: grid;\r\n  pointer-events: none;\r\n  z-index: 5;\r\n}\r\n\r\n.sudoku-notes.grid-3 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-template-rows: repeat(3, 1fr);\r\n}\r\n.sudoku-notes.grid-2 {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-template-rows: repeat(2, 1fr);\r\n}\r\n\r\n.note-num {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #cbd5e1; /* Кандидаты серые */\r\n  opacity: 0.7;\r\n  line-height: 1;\r\n}\r\n\r\n.sudoku-notes.grid-3 .note-num { font-size: 10px; font-weight: 700; }\r\n.sudoku-notes.grid-2 .note-num { font-size: 14px; font-weight: 700; }\r\n\r\n/* In selected cell, notes should be dark for contrast */\r\n.sudoku-cell.selected .note-num {\r\n    color: #000000;\r\n    opacity: 0.7;\r\n}\r\n\r\n/* --- CONTROLS --- */\r\n.sudoku-controls {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  flex: 1;\r\n}\r\n\r\n.sudoku-tools {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: center;\r\n}\r\n\r\n.tool-btn {\r\n  background: #334155;\r\n  border: 2px solid transparent; /* Reserve space for border */\r\n  border-radius: 8px;\r\n  color: #e2e8f0;\r\n  padding: 8px 16px;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  box-shadow: 0 4px 0 #1e293b;\r\n  transition: all 0.2s;\r\n}\r\n.tool-btn:active { transform: translateY(2px); box-shadow: 0 2px 0 #1e293b; }\r\n\r\n/* Pencil Button States */\r\n/* 1. Permanent ON - Light Gray Background */\r\n.tool-btn.note-active {\r\n  background: #cbd5e1;\r\n  color: #0f172a;\r\n  box-shadow: 0 4px 0 #94a3b8;\r\n}\r\n/* 2. Temporary ON - Dashed Border */\r\n.tool-btn.note-temp {\r\n  background: #334155; /* Normal bg */\r\n  border: 2px dashed #cbd5e1; /* Жирная пунктирная обводка */\r\n  color: #cbd5e1;\r\n}\r\n\r\n/* --- NUMPAD --- */\r\n.numpad {\r\n  display: grid;\r\n  gap: 6px;\r\n  padding: 0 4px;\r\n}\r\n.numpad.col-9 { grid-template-columns: repeat(9, 1fr); }\r\n.numpad.col-4 { grid-template-columns: repeat(4, 1fr); }\r\n\r\n.num-btn {\r\n  aspect-ratio: 1/1.2;\r\n  border: 1px solid #475569; /* Вернули рамку */\r\n  border-radius: 6px;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 3px 0 rgba(0,0,0,0.3);\r\n  transition: all 0.2s;\r\n  background: #1e293b; /* Темный фон всегда */\r\n}\r\n\r\n/* Numpad Colors based on MODE */\r\n.sudoku-board.mode-input .num-btn {\r\n  color: #38bdf8; /* Голубые цифры */\r\n  background: #1e293b;\r\n}\r\n\r\n.sudoku-board.mode-input .num-btn:hover {\r\n    background: #2a384c;\r\n}\r\n\r\n/* Mode: Notes (Gray) */\r\n.sudoku-board.mode-notes .num-btn {\r\n    background: #94a3b8; /* Серый */\r\n    color: #1e293b;\r\n}\r\n.sudoku-board.mode-notes .num-btn:hover {\r\n    background: #8796ab;;\r\n}\r\n\r\n\r\n/* --- MODAL (Report) --- */\r\n.ms-modal-overlay {\r\n    position: absolute; top:0; left:0; right:0; bottom:0;\r\n    background: rgba(0,0,0,0.7);\r\n    display: flex; align-items: center; justify-content: center;\r\n    z-index: 7000;\r\n    backdrop-filter: blur(2px);\r\n    border-radius: 12px;\r\n}\r\n.cs-report-card {\r\n    background: #1e293b;\r\n    border: 1px solid #475569;\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    width: 85%;\r\n    max-width: 350px;\r\n    text-align: center;\r\n    box-shadow: 0 10px 25px rgba(0,0,0,0.5);\r\n}\r\n.cs-report-header { margin-bottom: 15px; }\r\n.cs-report-title { font-size: 20px; font-weight: bold; color: #fff; }\r\n.cs-stats-grid { display: flex; flex-direction: column; gap: 8px; margin-bottom: 15px; }\r\n.cs-stat-row { display: flex; justify-content: space-between; font-size: 16px; border-bottom: 1px solid #334155; padding-bottom: 4px; }\r\n.cs-stat-label { color: #94a3b8; }\r\n.cs-stat-value { font-weight: bold; color: #e2e8f0; }\r\n.cs-stat-value.good { color: #4ade80; }\r\n.cs-stat-value.bad { color: #ef4444; }\r\n.cs-stat-value.rank-text { color: #fbbf24; }\r\n.cs-close-btn {\r\n    width: 100%; padding: 12px;\r\n    background: #3b82f6; color: white; border: none;\r\n    border-radius: 8px; font-weight: bold; cursor: pointer;\r\n}\r\n.cs-close-btn.secondary {\r\n    margin-top: 10px; background: transparent; border: 2px solid #555; color: #aaa;\r\n}\r\n\r\n/* MEDIA QUERIES */\r\n@media (max-width: 380px) {\r\n  .sudoku-grid.size-9 .sudoku-cell { font-size: 16px; }\r\n  .sudoku-notes.grid-3 .note-num { font-size: 8px; }\r\n  .numpad { gap: 2px; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
